// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0px;
    padding: 0px;
    font-family: "Open Sans", sans-serif;
    width: 100%;
    height: 100%;
}
.LayoutMain_Coral__bg-theme__yLm8o{
	background: #358696 !important;
    box-shadow: 0px 5px 5px rgb(0 0 0 / 14%);
}
.LayoutMain_Coral__headFont__fwYJG{
	font-size: 26px; font-weight: 600; margin-left: 55px; color: #fff;
}

/* .closed-sidebar.fixed-sidebar .app-main__outer{ */
	/* background: linear-gradient(180deg, #358696 0%, rgba(53, 134, 150, 0) 100%) !important; */
    /* height: 100%; */
/* } */

/********* Left Side Menu Section ********/
.LayoutMain_Coral__fixed-header__tQMCT .LayoutMain_Coral__app-main__4CD3g {
    padding-top: 80px;
}
.LayoutMain_Coral__app-sidebar__2BmmA .LayoutMain_Coral__app-sidebar__inner__m5iFS {
    padding: 20px 0px 0px !important;
}
.LayoutMain_Coral__app-sidebar__2BmmA .LayoutMain_Coral__app-sidebar__inner__m5iFS {
    padding: 45px 1.5rem 1.5rem;
    background: linear-gradient(180deg, #358696 0%, rgba(53, 134, 150, 0) 100%) !important; 
    height: 100%;
}
/* .app-sidebar__inner{ */
	/* background: linear-gradient(180deg, #358696 0%, rgba(53, 134, 150, 0) 100%) !important;  */
    /* height: 100%; */
/* } */
/* .app-sidebar{ */
	/* padding-top:80px !important; */
/* } */
.LayoutMain_Coral__app-header__b7Ed6{height:80px !important;}
.LayoutMain_Coral__colWhite__5ZoTB{color:#fff;}
.LayoutMain_Coral__hamburger-inner__oSRyS, .LayoutMain_Coral__hamburger-inner__oSRyS::before, .LayoutMain_Coral__hamburger-inner__oSRyS::after
{background-color:#fff !important;}


.LayoutMain_Coral__vertical-nav-menu__Kix3h li {
    text-indent: 15px;
    font-weight: 600 !important;
}

.LayoutMain_Coral__vertical-nav-menu__Kix3h i.LayoutMain_Coral__metismenu-state-icon__vXKCh, .LayoutMain_Coral__vertical-nav-menu__Kix3h i.LayoutMain_Coral__metismenu-icon__68ksQ {
    opacity: 1 !important;
    margin-right: 30px !important;
    top: 22px;
}
/* .vertical-nav-menu span.metismenu-state-icon, .vertical-nav-menu span.metismenu-icon { */
    /* opacity: 1 !important; */
    /* margin-right: 30px !important; */
    /* top: 22px; */
/* } */

.LayoutMain_Coral__vertical-nav-menu__Kix3h li a {
    color: #fff;
    font-size: 16px;
    font-weight: 600 !important;
    border-radius: 0px;
    margin: 8px 2% 8px 2%;
    text-indent: 10px;
    width: 96%;
    height: 50px;
}
.LayoutMain_Coral__vertical-nav-menu__Kix3h li a {
    padding: 5px 15px;
    /* text-indent: 25px; */
}
.LayoutMain_Coral__closed-sidebar__lU6oK .LayoutMain_Coral__app-sidebar__2BmmA .LayoutMain_Coral__app-sidebar__inner__m5iFS .LayoutMain_Coral__metismenu-icon__68ksQ {
    text-indent: 20px;
    left: 50%;
    margin-left: 0px;
}
.LayoutMain_Coral__link-title__pf6\\+M {
    margin-left: 10px;
}

/********* Left Side Menu Section Ends ********/

/********* Landing 2 Starts ********/
.LayoutMain_Coral__dashboard_card__tlydv {
    font-size: 18px;
    color: #000;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
    transition: 0.5s;
    background: #fff;
    border: solid 1px #c3c3c3;
    box-shadow: 1px 1px 25px #33333320;
    padding: 45px 15px 45px 15px;
    margin-top: 20px;
    width: 100%;
    /* max-width: 242px; */
}
.LayoutMain_Coral__dashboard_card__tlydv img {
    width: 50px;
}
.LayoutMain_Coral__dashboard_card__tlydv span {
    display: block;
    padding-top: 15px;
    font-weight: 600;
    line-height: 25px;
}
.LayoutMain_Coral__dashboard_card__tlydv:hover {
    box-shadow: 1px 1px 25px #999;
}
.LayoutMain_Coral__mobLogo__KBfO1 img{
	display:none;
}
.LayoutMain_Coral__MobView__P4Rc7{
	display:none;
}


/********* Media Queries Starts ********/


@media screen and (max-width: 991px) {
.LayoutMain_Coral__app-header__b7Ed6 .LayoutMain_Coral__app-header__content__69TjV {
    visibility: inherit !important;
    opacity: 1 !important;
     box-shadow: none !important; 
    background: transparent !important;
    position: relative !important;
    left: 5%;
     width: 90%; 
    top: 0;
    transition: all .2s;
    background: #fff;
    border-radius: 50px;
    padding: 0 10px;
    overflow: hidden;
}
.LayoutMain_Coral__app-header__content__69TjV .LayoutMain_Coral__dropdown__fPm7z{
	margin-right:30px !important;
}
.LayoutMain_Coral__app-header__logo__n4RrZ{display:none !important;}
}
@media screen and (max-width: 769px) {
  .LayoutMain_Coral__headFont__fwYJG, .LayoutMain_Coral__MobView__P4Rc7{
	font-size: 1em; font-weight: 600; margin-left: 25px; color: #fff;
}
.LayoutMain_Coral__MobView__P4Rc7{
	margin-left:0 ;
	display:block;
    background: #e2e2e2;
    font-size: 16px;
    color: #000;
    padding: 10px 15px;

}
.LayoutMain_Coral__headFont__fwYJG{
	display:none;
}
.LayoutMain_Coral__mobLogo__KBfO1 img{
	height:2em;
	margin-left:20px;
	display:block;
}
}
@media screen and (max-width: 420px) {

.LayoutMain_Coral__mobLogo__KBfO1 img{
	height:1.5em;
	margin-left:10px;
}
}

.LayoutMain_Coral__ev_card_title__97BlS span{
 font-size: 18px;
}
.LayoutMain_Coral__accordion-button__iPVhq:not(.LayoutMain_Coral__collapsed__WwsxH) {
    /* color: #0c63e4; */
    /* background-color: #e7f1ff; */
    box-shadow: inset  0 0  0.25rem rgb(53 134 150 / 43%);
    
}
.LayoutMain_Coral__accordion-button__iPVhq:focus {
    /* z-index: 3; */
    /* border-color: #86b7fe; */
    /* outline: 0; */
    box-shadow: 0 0 0 0.25rem rgb(53 134 150 / 43%);
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Coral/LayoutMain_Coral/LayoutMain_Coral_.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,WAAW;IACX,YAAY;AAChB;AACA;CACC,8BAA8B;IAC3B,wCAAwC;AAC5C;AACA;CACC,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,WAAW;AAClE;;AAEA,oDAAoD;CACnD,4FAA4F;IACzF,kBAAkB;AACtB,MAAM;;AAEN,0CAA0C;AAC1C;IACI,iBAAiB;AACrB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,2BAA2B;IAC3B,sFAAsF;IACtF,YAAY;AAChB;AACA,yBAAyB;CACxB,6FAA6F;IAC1F,kBAAkB;AACtB,MAAM;AACN,kBAAkB;CACjB,iCAAiC;AAClC,MAAM;AACN,qCAAY,sBAAsB,CAAC;AACnC,mCAAU,UAAU,CAAC;AACrB;CACC,gCAAgC,CAAC;;;AAGlC;IACI,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,SAAS;AACb;AACA,2FAA2F;IACvF,2BAA2B;IAC3B,mCAAmC;IACnC,eAAe;AACnB,MAAM;;AAEN;IACI,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,UAAU;IACV,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;AACA;IACI,iBAAiB;IACjB,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;;AAEA,+CAA+C;;AAE/C,oCAAoC;AACpC;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,kCAAkC;IAClC,4BAA4B;IAC5B,gBAAgB;IAChB,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,6BAA6B;AACjC;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;;;AAGA,wCAAwC;;;AAGxC;AACA;IACI,8BAA8B;IAC9B,qBAAqB;KACpB,2BAA2B;IAC5B,kCAAkC;IAClC,6BAA6B;IAC7B,QAAQ;KACP,UAAU;IACX,MAAM;IACN,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;AACA;CACC,4BAA4B;AAC7B;AACA,2CAAkB,uBAAuB,CAAC;AAC1C;AACA;EACE;CACD,cAAc,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,WAAW;AACjE;AACA;CACC,cAAc;CACd,aAAa;IACV,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,kBAAkB;;AAEtB;AACA;CACC,YAAY;AACb;AACA;CACC,UAAU;CACV,gBAAgB;CAChB,aAAa;AACd;AACA;AACA;;AAEA;CACC,YAAY;CACZ,gBAAgB;AACjB;AACA;;AAEA;CACC,eAAe;AAChB;AACA;IACI,oBAAoB;IACpB,+BAA+B;IAC/B,qDAAqD;;AAEzD;AACA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;IAChB,+CAA+C;AACnD","sourcesContent":["body {\n    margin: 0px;\n    padding: 0px;\n    font-family: \"Open Sans\", sans-serif;\n    width: 100%;\n    height: 100%;\n}\n.bg-theme{\n\tbackground: #358696 !important;\n    box-shadow: 0px 5px 5px rgb(0 0 0 / 14%);\n}\n.headFont{\n\tfont-size: 26px; font-weight: 600; margin-left: 55px; color: #fff;\n}\n\n/* .closed-sidebar.fixed-sidebar .app-main__outer{ */\n\t/* background: linear-gradient(180deg, #358696 0%, rgba(53, 134, 150, 0) 100%) !important; */\n    /* height: 100%; */\n/* } */\n\n/********* Left Side Menu Section ********/\n.fixed-header .app-main {\n    padding-top: 80px;\n}\n.app-sidebar .app-sidebar__inner {\n    padding: 20px 0px 0px !important;\n}\n.app-sidebar .app-sidebar__inner {\n    padding: 45px 1.5rem 1.5rem;\n    background: linear-gradient(180deg, #358696 0%, rgba(53, 134, 150, 0) 100%) !important; \n    height: 100%;\n}\n/* .app-sidebar__inner{ */\n\t/* background: linear-gradient(180deg, #358696 0%, rgba(53, 134, 150, 0) 100%) !important;  */\n    /* height: 100%; */\n/* } */\n/* .app-sidebar{ */\n\t/* padding-top:80px !important; */\n/* } */\n.app-header{height:80px !important;}\n.colWhite{color:#fff;}\n.hamburger-inner, .hamburger-inner::before, .hamburger-inner::after\n{background-color:#fff !important;}\n\n\n.vertical-nav-menu li {\n    text-indent: 15px;\n    font-weight: 600 !important;\n}\n\n.vertical-nav-menu i.metismenu-state-icon, .vertical-nav-menu i.metismenu-icon {\n    opacity: 1 !important;\n    margin-right: 30px !important;\n    top: 22px;\n}\n/* .vertical-nav-menu span.metismenu-state-icon, .vertical-nav-menu span.metismenu-icon { */\n    /* opacity: 1 !important; */\n    /* margin-right: 30px !important; */\n    /* top: 22px; */\n/* } */\n\n.vertical-nav-menu li a {\n    color: #fff;\n    font-size: 16px;\n    font-weight: 600 !important;\n    border-radius: 0px;\n    margin: 8px 2% 8px 2%;\n    text-indent: 10px;\n    width: 96%;\n    height: 50px;\n}\n.vertical-nav-menu li a {\n    padding: 5px 15px;\n    /* text-indent: 25px; */\n}\n.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-icon {\n    text-indent: 20px;\n    left: 50%;\n    margin-left: 0px;\n}\n.link-title {\n    margin-left: 10px;\n}\n\n/********* Left Side Menu Section Ends ********/\n\n/********* Landing 2 Starts ********/\n.dashboard_card {\n    font-size: 18px;\n    color: #000;\n    font-weight: 600;\n    text-align: center;\n    cursor: pointer;\n    transition: 0.5s;\n    background: #fff;\n    border: solid 1px #c3c3c3;\n    box-shadow: 1px 1px 25px #33333320;\n    padding: 45px 15px 45px 15px;\n    margin-top: 20px;\n    width: 100%;\n    /* max-width: 242px; */\n}\n.dashboard_card img {\n    width: 50px;\n}\n.dashboard_card span {\n    display: block;\n    padding-top: 15px;\n    font-weight: 600;\n    line-height: 25px;\n}\n.dashboard_card:hover {\n    box-shadow: 1px 1px 25px #999;\n}\n.mobLogo img{\n\tdisplay:none;\n}\n.MobView{\n\tdisplay:none;\n}\n\n\n/********* Media Queries Starts ********/\n\n\n@media screen and (max-width: 991px) {\n.app-header .app-header__content {\n    visibility: inherit !important;\n    opacity: 1 !important;\n     box-shadow: none !important; \n    background: transparent !important;\n    position: relative !important;\n    left: 5%;\n     width: 90%; \n    top: 0;\n    transition: all .2s;\n    background: #fff;\n    border-radius: 50px;\n    padding: 0 10px;\n    overflow: hidden;\n}\n.app-header__content .dropdown{\n\tmargin-right:30px !important;\n}\n.app-header__logo{display:none !important;}\n}\n@media screen and (max-width: 769px) {\n  .headFont, .MobView{\n\tfont-size: 1em; font-weight: 600; margin-left: 25px; color: #fff;\n}\n.MobView{\n\tmargin-left:0 ;\n\tdisplay:block;\n    background: #e2e2e2;\n    font-size: 16px;\n    color: #000;\n    padding: 10px 15px;\n\n}\n.headFont{\n\tdisplay:none;\n}\n.mobLogo img{\n\theight:2em;\n\tmargin-left:20px;\n\tdisplay:block;\n}\n}\n@media screen and (max-width: 420px) {\n\n.mobLogo img{\n\theight:1.5em;\n\tmargin-left:10px;\n}\n}\n\n.ev_card_title span{\n font-size: 18px;\n}\n.accordion-button:not(.collapsed) {\n    /* color: #0c63e4; */\n    /* background-color: #e7f1ff; */\n    box-shadow: inset  0 0  0.25rem rgb(53 134 150 / 43%);\n    \n}\n.accordion-button:focus {\n    /* z-index: 3; */\n    /* border-color: #86b7fe; */\n    /* outline: 0; */\n    box-shadow: 0 0 0 0.25rem rgb(53 134 150 / 43%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bg-theme": `LayoutMain_Coral__bg-theme__yLm8o`,
	"headFont": `LayoutMain_Coral__headFont__fwYJG`,
	"fixed-header": `LayoutMain_Coral__fixed-header__tQMCT`,
	"app-main": `LayoutMain_Coral__app-main__4CD3g`,
	"app-sidebar": `LayoutMain_Coral__app-sidebar__2BmmA`,
	"app-sidebar__inner": `LayoutMain_Coral__app-sidebar__inner__m5iFS`,
	"app-header": `LayoutMain_Coral__app-header__b7Ed6`,
	"colWhite": `LayoutMain_Coral__colWhite__5ZoTB`,
	"hamburger-inner": `LayoutMain_Coral__hamburger-inner__oSRyS`,
	"vertical-nav-menu": `LayoutMain_Coral__vertical-nav-menu__Kix3h`,
	"metismenu-state-icon": `LayoutMain_Coral__metismenu-state-icon__vXKCh`,
	"metismenu-icon": `LayoutMain_Coral__metismenu-icon__68ksQ`,
	"closed-sidebar": `LayoutMain_Coral__closed-sidebar__lU6oK`,
	"link-title": `LayoutMain_Coral__link-title__pf6+M`,
	"dashboard_card": `LayoutMain_Coral__dashboard_card__tlydv`,
	"mobLogo": `LayoutMain_Coral__mobLogo__KBfO1`,
	"MobView": `LayoutMain_Coral__MobView__P4Rc7`,
	"app-header__content": `LayoutMain_Coral__app-header__content__69TjV`,
	"dropdown": `LayoutMain_Coral__dropdown__fPm7z`,
	"app-header__logo": `LayoutMain_Coral__app-header__logo__n4RrZ`,
	"ev_card_title": `LayoutMain_Coral__ev_card_title__97BlS`,
	"accordion-button": `LayoutMain_Coral__accordion-button__iPVhq`,
	"collapsed": `LayoutMain_Coral__collapsed__WwsxH`
};
export default ___CSS_LOADER_EXPORT___;
